import ChatIcon from "@mui/icons-material/ChatOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import {
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import { generateMenuAriaControlsProps } from "components/Menu/accessibility.helpers";
import { MenuNodeType } from "components/Menu/model";
import { ParentNodeIcon } from "components/ParentNodeIcon";
import { useAvoTracking } from "hooks/useAvoTracking";

import { sharedStyles } from "../shared.styles";

import { menuContainerNodeStyles as styles } from "./MenuContainerNode.styles";

const icons = {
  language: <LanguageIcon />,
  chat: <ChatIcon />,
};

export interface MenuContainerNodeProps {
  node: MenuNodeType.Container;
  selectedMainMenuTitleKey?: string;
  onMenuClick: (titleKey: string) => void;
}

export const MenuContainerNode = ({
  node,
  selectedMainMenuTitleKey,
  onMenuClick,
}: MenuContainerNodeProps) => {
  const { trackMenuClick } = useAvoTracking();
  const open = selectedMainMenuTitleKey === node.titleKey;

  const handleMenuClick = () => {
    onMenuClick(node.titleKey);
    trackMenuClick({
      name: node.analyticsTag,
    });
  };

  return (
    <>
      <ListItemButton
        onClick={handleMenuClick}
        css={styles.open(open)}
        data-testid="menu-container-node"
        {...generateMenuAriaControlsProps({
          analyticsTag: node.analyticsTag,
          targetElementShown: open,
        })}
      >
        {node.icon && (
          <ListItemIcon>{icons[node.icon as keyof typeof icons]}</ListItemIcon>
        )}
        <ListItemText css={sharedStyles.listItemHeading}>
          {node.titleKey}
        </ListItemText>
        <ParentNodeIcon closedDirection="right" open={open} />
      </ListItemButton>
      <Divider />
    </>
  );
};
